import type { SVGProps } from "react";

export function IconPurpleCoins(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.3335 19.8333V12.8333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00016 22.1667C7.00016 25.3883 12.2235 28 18.6668 28C21.2938 28 23.7179 27.5659 25.668 26.8334"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99984 30.3333C6.99984 33.555 12.2232 36.1666 18.6665 36.1666C21.2929 36.1666 23.7166 35.7327 25.6665 35.0004"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99984 12.8333V38.5C6.99984 41.7216 12.2232 44.3333 18.6665 44.3333C21.293 44.3333 23.7166 43.899 25.6665 43.1666"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6667 35.5L25.6667 43.1667C25.6667 46.3883 30.89 49 37.3333 49C43.7767 49 49 46.3883 49 43.1667V34"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6668 18.6667C12.2235 18.6667 7.00016 16.055 7.00016 12.8333C7.00016 9.61167 12.2235 7 18.6668 7C25.1102 7 30.3335 9.61167 30.3335 12.8333C30.3335 16.055 25.1102 18.6667 18.6668 18.6667Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6667 26.5L25.6667 34.1667C25.6667 37.3883 30.89 40 37.3333 40C43.7767 40 49 37.3883 49 34.1667V25"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3333 30.3334C30.89 30.3334 25.6667 27.7217 25.6667 24.5C25.6667 21.2784 30.89 18.6667 37.3333 18.6667C43.7767 18.6667 49 21.2784 49 24.5C49 27.7217 43.7767 30.3334 37.3333 30.3334Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
